<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70vw" @close="handleDialogClose">
    <!-- 自定义菜单切换 -->
    <div class="datamenubox">
      <div :class="activeTab == 'deviceInfo' ? 'datamenuitem died' : 'datamenuitem'" @click="menuChange('deviceInfo')">
        设备信息
      </div>
      <div :class="activeTab == 'deviceData' ? 'datamenuitem died' : 'datamenuitem'" @click="menuChange('deviceData')">
        设备数据
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="dialog-content">
      <!-- 统一的表单容器 -->
      <el-form :model="formData" :rules="rules" ref="form" label-width="120px">
        <!-- 设备信息内容 -->
        <div v-show="activeTab == 'deviceInfo'" class="content-panel">
          <el-form-item label="设备编号">
            <el-input v-model="formData.deviceCode" placeholder="系统生成" style="width: 300px" readonly> </el-input>
          </el-form-item>
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入" maxlength="50" style="width: 300px" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="所属企业" prop="tenantId">
            <el-select
              v-model="formData.tenantId"
              placeholder="请选择"
              style="width: 300px"
              @change="handleTenantChange"
            >
              <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属大棚" prop="greenhouseId">
            <el-select
              v-model="formData.greenhouseId"
              placeholder="请选择"
              style="width: 300px"
              @change="handleGreenhouseChange"
            >
              <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属分类" prop="classify">
            <el-select v-model="formData.classify" placeholder="请选择" style="width: 300px">
              <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备位置">
            <el-input v-model="formData.location" placeholder="请输入" style="width: 300px"> </el-input>
          </el-form-item>
        </div>

        <!-- 设备数据内容 -->
        <div v-show="activeTab == 'deviceData'" class="content-panel">
          <!-- 设备数据配置区域 -->
          <div class="device-data-config">
            <el-form-item label="CBox" prop="cboxCode">
              <el-select
                v-model="formData.cboxCode"
                placeholder="请选择"
                style="width: 300px"
                @change="handleCboxCodeChange"
                clearable
              >
                <el-option v-for="item in cboxOptions" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="CBox IP" prop="cboxIp">
              <el-input v-model="formData.cboxIp" placeholder="选择CBox后自动带出" style="width: 300px" readonly>
              </el-input>
            </el-form-item>
            <el-form-item label="设备ID" prop="cboxDeviceId">
              <el-select
                v-model="formData.cboxDeviceId"
                placeholder="请选择"
                style="width: 300px"
                @change="handleCboxDeviceChange"
                clearable
                :disabled="!formData.cboxCode"
              >
                <el-option v-for="item in cboxDeviceOptions" :key="item.id" :label="`${item.name}`" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备参数" prop="deviceParams">
              <el-select
                v-model="formData.deviceParams"
                placeholder="请选择"
                style="width: 300px"
                multiple
                @change="handleDeviceParamsChange"
                clearable
                :disabled="!formData.cboxDeviceId"
              >
                <el-option
                  v-for="item in deviceParamsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- 设备变量配置表格 -->
          <div class="parameter-table">
            <el-table :data="formData.deviceVariableList" border style="width: 100%">
              <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
              <el-table-column label="参数类型" width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.type" placeholder="请选择" style="width: 100%">
                    <el-option
                      v-for="item in variableTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="参数名称" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="id绑定" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.uniqueId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="变量ID" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.uniqueId ? scope.row.uniqueId.split('_').pop() : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单位" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.unit" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="标准值区间 (下限-上限)" width="250">
                <template slot-scope="scope">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <el-input
                      v-model="scope.row.lowerLimit"
                      placeholder="请输入"
                      size="small"
                      style="flex: 1"
                    ></el-input>
                    <span>-</span>
                    <el-input
                      v-model="scope.row.upperLimit"
                      placeholder="请输入"
                      size="small"
                      style="flex: 1"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button type="text" style="color: #2680dd" @click="removeVariable(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit"> 确定 </el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'MonitoringEquipmentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: 'deviceInfo', // 当前激活的标签页
      formData: {
        id: undefined,
        deviceCode: '', // 设备编号（系统生成）
        name: '', // 设备名称
        tenantId: '', // 所属企业id
        tenantName: '', // 所属企业名称
        greenhouseId: '', // 大棚编号id
        greenhouseName: '', // 大棚编号
        classify: '', // 所属分类id
        categoryName: '', // 所属分类名称
        location: '', // 设备位置
        cboxCode: '', // CBOX编码
        cboxDeviceId: '', // CBOX设备id
        cboxIp: '', // CBOXip
        deviceParams: [], // 设备参数（多选）
        deviceVariableList: [], // 设备变量列表
      },
      submitLoading: false,
      tenantOptions: [],
      greenhouseOptions: [],
      categoryOptions: [
        { label: '土壤PH传感器', value: '1' },
        { label: '土壤氮磷钾传感器', value: '2' },
        { label: '土壤温湿度EC传感器', value: '3' },
        { label: '大气环境监测传感器', value: '4' },
        { label: '棚外气象站', value: '5' },
      ], // 分类选项
      variableTypeOptions: [], // 参数类型选项
      cboxData: [], // CBOX数据
      cboxOptions: [], // CBox编码选项
      cboxDeviceOptions: [], // CBox设备选项
      deviceParamsOptions: [], // 设备参数选项
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        tenantId: [{ required: true, message: '请选择所属企业', trigger: 'change' }],
        greenhouseId: [{ required: true, message: '请选择所属大棚', trigger: 'change' }],
        classify: [{ required: true, message: '请选择所属分类', trigger: 'change' }],
        cboxCode: [{ required: true, message: '请选择CBox', trigger: 'change' }],
        cboxDeviceId: [{ required: true, message: '请选择设备ID', trigger: 'change' }],
        deviceParams: [{ required: true, message: '请选择设备参数', trigger: 'change' }],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑' : '新增';
    },
  },
  watch: {
    'visible'(val) {
      this.dialogVisible = val;
      if (val) {
        this.initDialog();
      }
    },
    'dialogVisible'(val) {
      this.$emit('update:visible', val);
    },
    // 分类变化时，重新获取参数类型
    async 'formData.classify'(val, oldVal) {
      if (val) {
        await this.fetchVariableTypeOptions();
        // 只在非编辑模式或分类真正改变时才清空参数类型值
        // 编辑模式下首次赋值不清空（oldVal为空字符串或undefined）
        if (!this.isEdit || (oldVal && oldVal !== val)) {
          if (this.formData.deviceVariableList && this.formData.deviceVariableList.length > 0) {
            this.formData.deviceVariableList.forEach((item) => {
              item.type = '';
            });
          }
        }
      }
    },
  },
  created() {
    this.fetchTenantOptions();
    this.fetchGreenhouseOptions();
    this.fetchVariableTypeOptions();
    this.fetchCboxData();
  },
  methods: {
    // 菜单切换方法
    menuChange(tab) {
      // 新增时，未选择分类不允许进入“设备数据”页签
      if (!this.isEdit && tab === 'deviceData' && !this.formData.classify) {
        this.$message && this.$message.warning('请先选择所属分类');
        return;
      }
      this.activeTab = tab;
    },
    // 初始化弹窗
    async initDialog() {
      this.activeTab = 'deviceInfo';
      if (this.isEdit && this.editData) {
        // 处理设备变量数据
        let deviceVariableList = [];
        let deviceParams = [];

        if (this.editData.deviceVariables && Array.isArray(this.editData.deviceVariables)) {
          deviceVariableList = this.editData.deviceVariables.map((variable) => ({
            id: variable.id,
            type: variable.type,
            name: variable.name,
            uniqueId: variable.uniqueId,
            unit: variable.unit || '',
            lowerLimit: variable.lowerLimit || '',
            upperLimit: variable.upperLimit || '',
            dataType: variable.dataType,
          }));

          // 从设备变量中提取设备参数编码
          deviceParams = this.editData.deviceVariables
            .map((variable) => {
              const parts = variable.uniqueId ? variable.uniqueId.split('_') : [];
              return parts.length >= 3 ? parts[2] : null;
            })
            .filter((param) => param !== null);
        } else if (this.editData.deviceVariableList) {
          deviceVariableList = this.editData.deviceVariableList;
          deviceParams = this.editData.deviceParams || [];
        }

        setTimeout(() => {
          this.initCboxCascadeData();
          this.formData = {
            id: this.editData.id,
            deviceCode: this.editData.deviceCode || '',
            name: this.editData.name || '',
            tenantId: this.editData.tenantId || '',
            tenantName: this.editData.tenantName || '',
            greenhouseId: this.editData.greenhouseId || '',
            greenhouseName: this.editData.greenhouseName || '',
            classify: this.editData.classify.toString() || '',
            categoryName: this.editData.categoryName || '',
            location: this.editData.location || '',
            cboxCode: this.editData.cboxCode || '',
            cboxDeviceId: this.editData.cboxDeviceId || '',
            cboxIp: this.editData.cboxIp || '',
            deviceParams,
            deviceVariableList: deviceVariableList,
          };
        }, 800);
      } else {
        this.resetForm();
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 初始化CBox级联数据（编辑模式专用）
    initCboxCascadeData() {
      if (!this.editData.cboxCode) {
        return;
      }

      const selectedCbox = this.cboxOptions.find((item) => item.code == this.editData.cboxCode);

      if (selectedCbox) {
        this.cboxDeviceOptions = selectedCbox.children.map((device) => ({
          id: device.id,
          code: device.code,
          name: device.name,
          children: device.children || [],
        }));
        if (this.editData.cboxDeviceId) {
          const selectedDevice = this.cboxDeviceOptions.find((item) => item.code == this.editData.cboxDeviceId);
          if (selectedDevice && selectedDevice.children) {
            this.deviceParamsOptions = selectedDevice.children.map((param) => ({
              value: param.code,
              label: param.name,
              dataType: param.dataType,
            }));
          }
        }
      }
    },
    // 重置表单
    resetForm() {
      this.formData = {
        id: undefined,
        deviceCode: '',
        name: '',
        tenantId: '',
        tenantName: '',
        greenhouseId: '',
        greenhouseName: '',
        classify: '',
        categoryName: '',
        location: '',
        cboxCode: '',
        cboxDeviceId: '',
        cboxIp: '',
        deviceParams: [],
        deviceVariableList: [],
      };
      this.cboxDeviceOptions = [];
      this.deviceParamsOptions = [];
    },
    // 获取企业列表
    async fetchTenantOptions() {
      const res = await axios.get(baseUrl + '/api/system/users');
      const agriTechUsers = res.data.filter(
        (user) => user.roleCodes && user.roleCodes.split(',').includes('company_admin')
      );
      this.tenantOptions = agriTechUsers.map((item) => ({
        label: item.nickName,
        value: item.id,
      }));
    },
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append('enableStatus', 1);
      const greenhouseRes = await axios.post(baseUrl + '/api/basic/greenhouse/selection', formData);
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },

    // 获取参数类型列表
    async fetchVariableTypeOptions() {
      if (!this.formData.classify) {
        return;
      }
      try {
        const res = await axios.post(baseUrl + '/api/device/device-info/monitoring-variable-type', {
          deviceType: 'MONITORING_DEVICE',
          classify: this.formData.classify,
        });
        this.variableTypeOptions = res.data.map((item) => ({
          label: item.value,
          value: item.key,
        }));
      } catch (error) {
        console.error('获取参数类型失败:', error);
        // 默认选项
        this.variableTypeOptions = [{ label: '监测数值', value: 'monitoring' }];
      }
    },
    // 获取企业下大棚列表
    async fetchGreenhouseOptionsByTenant(tenantId) {
      const formData = new FormData();
      formData.append('tenantId', tenantId);
      formData.append('enableStatus', 1);

      const greenhouseRes = await axios.post(baseUrl + '/api/basic/greenhouse/selection', formData);
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
      ``;
    },
    // 获取cbox数据
    async fetchCboxData() {
      try {
        const apiUrl = `/gbox-iot/gbox/management/cascade/project?code=PR202504180001`;
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        console.log('cboxData', res);

        this.cboxData = res.data.tree[0].children;

        this.cboxOptions = this.cboxData.map((item) => ({
          code: item.code,
          name: item.name,
          ip: item.ip,
          children: item.children || [],
        }));
      } catch (error) {
        console.error('获取CBox数据失败:', error);
        this.$message && this.$message.error('获取CBox数据失败');
      }
    },
    // CBox编码变化处理
    handleCboxCodeChange(cboxCode) {
      this.formData.cboxDeviceId = '';
      this.formData.cboxIp = '';
      this.formData.deviceParams = [];
      this.cboxDeviceOptions = [];
      this.deviceParamsOptions = [];
      this.formData.deviceVariableList = [];

      if (cboxCode) {
        const selectedCbox = this.cboxOptions.find((item) => item.code == cboxCode);
        if (selectedCbox) {
          this.formData.cboxIp = selectedCbox.ip || '';
          this.cboxDeviceOptions = selectedCbox.children.map((device) => ({
            id: device.id,
            code: device.code,
            name: device.name,
            children: device.children || [],
          }));

          if (this.isEdit && cboxCode == this.editData.cboxCode) {
            this.formData.cboxDeviceId = this.editData.cboxDeviceId;
            this.formData.deviceParams = this.editData.deviceParams || [];
            this.formData.deviceVariableList = this.editData.deviceVariableList || [];

            if (this.formData.cboxDeviceId) {
              this.$nextTick(() => {
                this.handleCboxDeviceChange(this.formData.cboxDeviceId);
              });
            }
          }
        }
      }
    },
    // CBox设备变化处理
    handleCboxDeviceChange(deviceId) {
      this.formData.deviceParams = [];
      this.deviceParamsOptions = [];

      if (!this.isEdit) {
        this.formData.deviceVariableList = [];
      }

      if (deviceId) {
        const selectedDevice = this.cboxDeviceOptions.find((item) => item.code == deviceId);
        if (selectedDevice && selectedDevice.children) {
          this.deviceParamsOptions = selectedDevice.children.map((param) => ({
            value: param.code,
            label: param.name,
            dataType: param.dataType,
          }));

          if (this.isEdit) {
            this.formData.deviceVariableList = this.editData.deviceVariableList || [];
            this.formData.deviceParams = this.editData.deviceParams || [];
          }
        }
      }
    },
    // 设备参数变化处理
    handleDeviceParamsChange(selectedParams) {
      const currentVariables = {};
      this.formData.deviceVariableList.forEach((item) => {
        currentVariables[item.uniqueId] = {
          ...item,
        };
      });

      this.formData.deviceVariableList = [];

      selectedParams.forEach((paramCode) => {
        const paramInfo = this.deviceParamsOptions.find((item) => item.value == paramCode);
        if (!paramInfo) return;

        const uniqueId = `${this.formData.cboxCode}_${this.formData.cboxDeviceId}_${paramCode}`;
        if (currentVariables[uniqueId]) {
          // 保留已有的所有字段，包括type
          this.formData.deviceVariableList.push({
            ...currentVariables[uniqueId],
            name: paramInfo.label, // 更新名称
            uniqueId,
            dataType: paramInfo.dataType,
          });
        } else {
          this.formData.deviceVariableList.push({
            type: this.variableTypeOptions.length > 0 ? this.variableTypeOptions[0].value : '',
            name: paramInfo.label,
            uniqueId,
            unit: '',
            lowerLimit: '',
            upperLimit: '',
            dataType: paramInfo.dataType,
          });
        }
      });
    },
    // 企业变化处理
    async handleTenantChange() {
      this.formData.greenhouseId = '';
      this.formData.greenhouseName = '';

      if (this.formData.tenantId) {
        await this.fetchGreenhouseOptionsByTenant(this.formData.tenantId);
      }
    },
    // 大棚变化处理
    handleGreenhouseChange() {
      const selectedGreenhouse = this.greenhouseOptions.find((item) => item.value == this.formData.greenhouseId);
      if (selectedGreenhouse) {
        this.formData.greenhouseName = selectedGreenhouse.label;
      }
    },
    // 删除设备变量
    removeVariable(index) {
      const removedVariable = this.formData.deviceVariableList[index];
      this.formData.deviceVariableList.splice(index, 1);
      this.updateDeviceParamsFromVariables();
    },
    // 根据当前变量列表更新设备参数绑定值
    updateDeviceParamsFromVariables() {
      const currentParams = this.formData.deviceVariableList
        .map((variable) => {
          const parts = variable.uniqueId ? variable.uniqueId.split('_') : [];
          return parts.length >= 3 ? parts[2] : null;
        })
        .filter((param) => param !== null);
      this.formData.deviceParams = currentParams;
    },
    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        if (error !== false) {
          console.error('表单验证失败:', error);
        }
        return;
      }

      this.submitLoading = true;
      try {
        const submitData = {
          ...this.formData,
          deviceType: 'MONITORING_DEVICE',
          tenantName: this.tenantOptions.find((t) => t.value == this.formData.tenantId)?.label || '',
          greenhouseName: this.greenhouseOptions.find((g) => g.value == this.formData.greenhouseId)?.label || '',
          categoryName: this.categoryOptions.find((c) => c.value == this.formData.classify)?.label || '',
        };

        const url = this.isEdit ? '/api/device/device-info/edit' : '/api/device/device-info/add';

        const res = await axios.post(baseUrl + url, submitData);

        if (res.code === 200) {
          this.$message && this.$message.success(this.isEdit ? '更新成功' : '新增成功');
          this.$emit('submitted', submitData);
          this.dialogVisible = false;
        } else {
          const message = res.msg || '提交失败';
          console.error('提交失败:', res);
        }
      } catch (error) {
        console.error('提交失败:', error);
      } finally {
        this.submitLoading = false;
      }
    },
    // 取消
    handleCancel() {
      this.dialogVisible = false;
    },
    // 弹窗关闭
    handleDialogClose() {
      this.resetForm();
    },
  },
};
</script>

<style scoped lang="less">
.datamenubox {
  margin: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;

  .datamenuitem {
    padding: 10px 20px;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    background-image: url('../../../assets/img/data/btn.png');
    background-size: 100% 100%;
  }

  .died {
    background-image: url('../../../assets/img/data/btned.png');
  }
}

.dialog-content {
  padding: 20px;

  .content-panel {
    min-height: 400px;
  }

  .device-data-config {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
  }

  .form-tip {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }

  .parameter-table {
    margin-top: 20px;
  }
}
</style>
